module.exports = __webpack_public_path__ + "img/V-R-5-load-connect-shadow.cbb469af.png";